import React, { useState, useEffect } from "react";
import "./style.css";
import api from "../../services/api";
import { useAppContext } from '../../context/AppContext.js';

const Post = ({ post }) => {
  const { codcolaborador, selectedCompany, codassinante, accessKey } = useAppContext(); // Acessa os dados do contexto 
  const [likes, setLikes] = useState(post.likes);
  const [liked, setLiked] = useState(false); // Estado para saber se o colaborador já curtiu
  const { DateTime } = require("luxon");

  // Verifica se o colaborador já curtiu o post
  useEffect(() => {
    api
      .get("/v1/cadastro/colaborador/feed/apoio", {
        params: {
          codfeed: post.codfeed,
          codcolaborador,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then((response) => {
        if (response.data.length > 0) {
          setLiked(true);
        }
      })
      .catch((err) => {
        console.log("Erro ao verificar curtida:", err);
      });
  }, [post.codfeed, codcolaborador, accessKey]);

  // Lógica para curtir o post
  const handleLike = () => {
    api
      .post(
        "/v1/cadastro/colaborador/feed/apoio",
        {
          excluido: "N",
          codfeed: post.codfeed,
          codcolaborador,
          codassinante,
          codempresa: selectedCompany,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        setLikes(likes + 1);
        setLiked(true); // Atualiza o estado para curtido
      })
      .catch((err) => {
        console.log("Erro ao curtir o post:", err);
      });
  };

  // Lógica para descurtir o post
  const handleUnlike = () => {
    api
      .delete("/v1/cadastro/colaborador/feed/apoio", {
        data: {
          codfeed: post.codfeed,  
          codcolaborador,        
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        setLikes(likes - 1);
        setLiked(false); // Atualiza o estado para não curtido
      })
      .catch((err) => {
        console.log("Erro ao descurtir o post:", err);
      });
  };

  function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

  return (
    <div className="post">
      <div className="post-header">
        <h4>{post.nome}</h4>
        <span>{FormataDataHora(post.dtlancamento)}</span>
      </div>
      <p>{post.texto}</p>
      <div className="post-footer">
        {liked ? (
          <button className="btnred" onClick={handleUnlike}>Descurtir</button>
        ) : (
          <button className="btngreen" onClick={handleLike}>Curtir</button>
        )}
        <span>{likes} likes</span>
      </div>
    </div>
  );
};

export default Post;
